import { Box } from "@mui/material";
import AdminPuzzlePlay from "./AdminGridPlay";

export default function AdminPlayMain() {
    return (
        <Box>
            <AdminPuzzlePlay />
        </Box>
    );
}
